'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.millisecondsUntil;


// WEBPACK FOOTER //
// ./~/sugar-date/date/millisecondsUntil.js